import React, { useState } from 'react';
import api from '../services/api';
import { Card, Form, Button, Alert, Container, Spinner, Badge } from 'react-bootstrap';
import { FaSignInAlt, FaLock, FaEnvelope, FaQuestionCircle, FaExclamationCircle } from 'react-icons/fa';

const Login = ({ onLogin, setCurrentView }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const res = await api.post('/api/auth/login', { 
             
                email: email.trim().toLowerCase(),
                password 
            });

            // Nếu đăng nhập thành công
            if (res.data.success || res.data.token) {
                const { token, user } = res.data;
                const role = user?.role || res.data.role || 'user';

                // =========================================================================
                // 🔒 BỘ GHIM CỨNG TOKEN V5: CHỐNG "BAY MÀU" DỮ LIỆU KHI CHUYỂN MÀN HÌNH
                // =========================================================================
                localStorage.setItem('token', token);
                localStorage.setItem('jwtToken', token);
                localStorage.setItem('accessToken', token);
                localStorage.setItem('role', role);
                if (user) {
                    localStorage.setItem('user', JSON.stringify(user));
                }

                console.log("✅ [LOGIN] Đã găm Token vĩnh cửu vào đĩa cứng LocalStorage thành công!");

                // Kích hoạt hàm sảnh chính
                onLogin(token, user || { email, role });

                if (role === 'admin') {
                    setCurrentView('admin-dashboard');
                } else {
                    setCurrentView('dashboard');
                }
            }
        } catch (err) {
            const errorData = err.response?.data;
            console.error("Lỗi đăng nhập:", errorData);

            if (errorData?.requiresVerification) {
                setError(errorData.message); 
                setTimeout(() => {
                    setCurrentView('register');
                }, 2000);
            } else {
                setError(errorData?.message || 'Email hoặc mật khẩu không đúng');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="d-flex align-items-center justify-content-center" style={{ minHeight: '80vh' }}>
            <Card className="shadow-lg border-0 animate__animated animate__fadeIn" style={{ maxWidth: '420px', width: '100%', borderRadius: '15px', overflow: 'hidden' }}>
                <div className="text-center p-4" style={{ background: 'linear-gradient(135deg, #111827 0%, #374151 100%)', borderBottom: '4px solid #ccac00' }}>
                    <Badge bg="warning" text="dark" className="mb-2 px-3 fw-bold">NEXBOT ACCESS</Badge>
                    <h3 className="text-warning fw-black mb-0 text-uppercase" style={{ letterSpacing: '1px' }}>Đăng nhập hệ thống</h3>
                </div>
                <Card.Body className="p-4 bg-white text-dark">
                    {error && (
                        <Alert variant={error.includes("chưa xác thực") ? "warning" : "danger"} className="small fw-bold border-0 shadow-sm text-center">
                            <FaExclamationCircle className="me-2"/>
                            {error}
                        </Alert>
                    )}
                    
                    <Form onSubmit={handleSubmit}>
                        <Form.Group className="mb-3">
                            <Form.Label className="fw-bold small text-muted"><FaEnvelope className="me-1"/> ĐỊA CHỈ EMAIL</Form.Label>
                            <Form.Control 
                                type="email" 
                                value={email} 
                                onChange={(e) => setEmail(e.target.value)} 
                                required 
                                placeholder="nhập email"
                                disabled={loading}
                                style={{ height: '45px', border: '2px solid #eee', borderRadius: '8px' }} 
                            />
                        </Form.Group>

                        <Form.Group className="mb-2">
                            <Form.Label className="fw-bold small text-muted"><FaLock className="me-1"/> MẬT KHẨU</Form.Label>
                            <Form.Control 
                                type="password" 
                                value={password} 
                                onChange={(e) => setPassword(e.target.value)} 
                                required 
                                placeholder="••••••••"
                                disabled={loading}
                                style={{ height: '45px', border: '2px solid #eee', borderRadius: '8px' }} 
                            />
                        </Form.Group>

                        <div className="text-end mb-4">
                            <Button 
                                variant="link" 
                                className="p-0 text-muted small text-decoration-none fw-bold"
                                onClick={() => setCurrentView('forgot-password')}
                                style={{ fontSize: '0.75rem' }}
                            >
                                <FaQuestionCircle className="me-1"/> Quên mật khẩu?
                            </Button>
                        </div>

                        <Button 
                            variant="dark" 
                            type="submit" 
                            className="w-100 py-3 fw-black text-warning shadow border-0" 
                            disabled={loading}
                            style={{ borderRadius: '10px', letterSpacing: '1px', background: '#111827' }}
                        >
                            {loading ? <Spinner size="sm" animation="border" /> : <><FaSignInAlt className="me-2"/> ĐĂNG NHẬP</>}
                        </Button>
                    </Form>

                    <div className="text-center mt-4 pt-2 border-top">
                        <span className="text-muted small fw-bold">Chưa có tài khoản?</span><br/>
                        <Button 
                            variant="link" 
                            className="text-decoration-none fw-black text-uppercase p-0 mt-1"
                            onClick={() => setCurrentView('register')} 
                            style={{ color: '#ccac00', fontSize: '0.85rem' }}
                        >
                            Đăng ký tài khoản mới ngay
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default Login;